import './App.css';
import './components/UserMenu.css';
import './components/Navigation.css';
import './components/Logo.css';
import { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from 'react-router-dom';

function App() {
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [activeTab, setActiveTab] = useState('home');
  const [showSignUp, setShowSignUp] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [actionFormData, setActionFormData] = useState({
    startDate: '',
    duration: '',
    requirements: '',
    additionalNotes: ''
  });
  const [loggedInUser, setLoggedInUser] = useState(() => {
    const saved = localStorage.getItem('user');
    return saved ? JSON.parse(saved) : null;
  });
  const [signInData, setSignInData] = useState({
    email: '',
    password: ''
  });
  const [signUpData, setSignUpData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    name: ''
  });
  const [formData, setFormData] = useState({
    agentName: '',
    category: '',
    primaryFunction: '',
    requirements: '',
    priority: '',
    timeline: '',
    features: []
  });
  
  const handleFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === 'checkbox') {
      const features = [...formData.features];
      if (checked) {
        features.push(value);
      } else {
        const index = features.indexOf(value);
        if (index > -1) {
          features.splice(index, 1);
        }
      }
      setFormData(prev => ({ ...prev, features }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSignUpSubmit = (e) => {
    e.preventDefault();
    if (signUpData.password !== signUpData.confirmPassword) {
      alert('Passwords do not match!');
      return;
    }
    
    // Store user data in localStorage with initial credit points
    const userData = {
      name: signUpData.name,
      email: signUpData.email,
      password: signUpData.password,
      creditPoints: 100,    // Initialize with 100 credit points
      avatar: `https://api.dicebear.com/7.x/initials/svg?seed=${signUpData.name}` // Generate avatar from initials
    };
    
    // Get existing users or initialize empty array
    const existingUsers = JSON.parse(localStorage.getItem('users') || '[]');    // Check if email already exists
    if (existingUsers.some(user => user.email === userData.email)) {
      alert('An account with this email already exists!');
      return;
    }
    
    // Add new user
    existingUsers.push(userData);
    localStorage.setItem('users', JSON.stringify(existingUsers));
    
    // Log user in
    setLoggedInUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
    
    alert('Sign up successful!');
    setSignUpData({
      email: '',
      password: '',
      confirmPassword: '',
      name: ''
    });
    setActiveTab('home');
    window.location.href = '/';
  };

  const handleSignUpChange = (e) => {
    const { name, value } = e.target;
    setSignUpData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSignInChange = (e) => {
    const { name, value } = e.target;
    setSignInData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSignInSubmit = (e) => {
    e.preventDefault();
    const users = JSON.parse(localStorage.getItem('users') || '[]');
    const user = users.find(u => u.email === signInData.email && u.password === signInData.password);
    
    if (user) {
      setLoggedInUser(user);
      localStorage.setItem('user', JSON.stringify(user));
      setSignInData({ email: '', password: '' });
      setActiveTab('home');
      window.location.href = '/';  // Navigate to home
    } else {
      alert('Invalid email or password');
    }
  };


  const handleSignOut = () => {
    setLoggedInUser(null);
    localStorage.removeItem('user');
    setActiveTab('home');
    setShowProfileMenu(false);
  };

  const handleAgentSelect = (agent, category) => {
    setSelectedAgent({ ...agent, category: category.name });
    setActionFormData({
      startDate: '',
      duration: '',
      requirements: '',
      additionalNotes: ''
    });
  };

  const handleActionFormChange = (e) => {
    const { name, value } = e.target;
    setActionFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

    const handleActionFormSubmit = (e) => {
    e.preventDefault();
    if (!loggedInUser) {
      alert('Please sign in to submit a request');
      setActiveTab('signin');
      return;
    }

    // Calculate credit cost based on category
    const baseCreditCost = selectedAgent.category === "Healthcare" ? 15 :
                          selectedAgent.category === "Legal" ? 20 :
                          selectedAgent.category === "Finance & Accounting" ? 25 :
                          selectedAgent.category === "Marketing" ? 18 :
                          selectedAgent.category === "Human Resources" ? 15 :
                          selectedAgent.category === "Fitness & Wellness" ? 12 :
                          selectedAgent.category === "Education" ? 15 :
                          10;

    // Calculate additional costs based on duration
    const durationMonths = parseInt(actionFormData.duration);
    const monthlyCost = selectedAgent.category === "Healthcare" ? 5 :
                       selectedAgent.category === "Legal" ? 8 :
                       selectedAgent.category === "Finance & Accounting" ? 10 :
                       selectedAgent.category === "Marketing" ? 7 :
                       selectedAgent.category === "Human Resources" ? 5 :
                       selectedAgent.category === "Fitness & Wellness" ? 4 :
                       selectedAgent.category === "Education" ? 5 :
                       3;
    
    const totalCost = baseCreditCost + (monthlyCost * durationMonths);

    // Check if user has enough credits
    if (loggedInUser.creditPoints < totalCost) {
      alert(`Not enough credit points! This request requires ${totalCost} credits (${baseCreditCost} base cost + ${monthlyCost} credits/month for ${durationMonths} months).`);
      return;
    }

    // Update user's credit points
    const updatedCreditPoints = loggedInUser.creditPoints - totalCost;
    
    // Update logged in user state
    setLoggedInUser({
      ...loggedInUser,
      creditPoints: updatedCreditPoints
    });

    // Update user's credit points in localStorage
    const users = JSON.parse(localStorage.getItem('users') || '[]');
    const updatedUsers = users.map(user => 
      user.email === loggedInUser.email 
        ? { ...user, creditPoints: updatedCreditPoints }
        : user
    );
    localStorage.setItem('users', JSON.stringify(updatedUsers));
    localStorage.setItem('user', JSON.stringify({ ...loggedInUser, creditPoints: updatedCreditPoints }));

    // Here you would typically send the data to your backend
    console.log('Action form submitted:', { 
      agent: selectedAgent, 
      ...actionFormData, 
      creditCost: {
        base: baseCreditCost,
        monthly: monthlyCost,
        duration: durationMonths,
        total: totalCost
      }
    });
    alert(`Request submitted successfully!\nCredit usage:\n- Base cost: ${baseCreditCost}\n- Monthly cost: ${monthlyCost} × ${durationMonths} months\n- Total used: ${totalCost}\nRemaining credits: ${updatedCreditPoints}`);
    setSelectedAgent(null);
    setActionFormData({
      startDate: '',
      duration: '',
      requirements: '',
      additionalNotes: ''
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Here you would typically send the data to your backend
    alert('Request submitted successfully!');
    setFormData({
      agentName: '',
      category: '',
      primaryFunction: '',
      requirements: '',
      priority: '',
      timeline: '',
      features: []
    });
  };
  
  const categories = [
    {
      name: "Healthcare",
      description: "AI solutions for medical practices, patient care, and healthcare administration",
      icon: "🏥",
      agents: [
        { name: "Clinic Management AI", status: "Active" },
        { name: "Doctor's Assistant AI", status: "Active" },
        { name: "Patient Care AI", status: "Active" },
        { name: "Insurance Claims AI", status: "Active" }
      ]
    },
    {
      name: "Construction & Architecture",
      description: "Smart solutions for construction planning, architectural design, and project management",
      icon: "🏗️",
      agents: [
        { name: "Contractor AI Assistant", status: "Active" },
        { name: "Architect Design AI", status: "Active" },
        { name: "Developer Planning AI", status: "Active" }
      ]
    },
    {
      name: "Legal",
      description: "AI-powered legal assistance for document review, research, and contract analysis",
      icon: "⚖️",
      agents: [
        { name: "Document Review Assistant", status: "Active" },
        { name: "Legal Research Agent", status: "Active" },
        { name: "Contract Analyzer", status: "Training" }
      ]
    },
    {
      name: "Finance & Accounting",
      description: "Financial analysis, tax planning, and fraud detection powered by AI",
      icon: "💰",
      agents: [
        { name: "Financial Forecasting", status: "Active" },
        { name: "Tax Analysis Assistant", status: "Active" },
        { name: "Fraud Detection Agent", status: "Active" }
      ]
    },
    {
      name: "Marketing",
      description: "Digital marketing solutions for campaign optimization and content creation",
      icon: "📊",
      agents: [
        { name: "Campaign Optimizer", status: "Active" },
        { name: "Social Media Manager", status: "Active" },
        { name: "Content Generator", status: "Active" }
      ]
    },
    {
      name: "Human Resources",
      description: "AI tools for recruitment, employee onboarding, and HR policy management",
      icon: "👥",
      agents: [
        { name: "Recruitment Assistant", status: "Active" },
        { name: "Employee Onboarding", status: "Training" },
        { name: "HR Policy Advisor", status: "Active" }
      ]
    },
    {
      name: "Fitness & Wellness",
      description: "Personalized AI solutions for fitness planning, nutrition, and wellness coaching",
      icon: "💪",
      agents: [
        { name: "Workout Planner", status: "Active" },
        { name: "Nutrition Advisor", status: "Active" },
        { name: "Wellness Coach", status: "Active" }
      ]
    },
    {
      name: "Education",
      description: "Educational AI tools for learning path creation and student progress tracking",
      icon: "📚",
      agents: [
        { name: "Learning Path Creator", status: "Active" },
        { name: "Student Progress Analyzer", status: "Active" },
        { name: "Course Content Generator", status: "Training" }
      ]
    }
  ];


  const renderContent = (tab) => {
    switch (tab || activeTab) {
      case 'signin':
        return (
          <div className="signup-form-container">
            <form className="signup-form" onSubmit={handleSignInSubmit}>
              <h2>Sign In</h2>
              <div className="form-group">
                <label htmlFor="signin-email">Email</label>
                <input
                  type="email"
                  id="signin-email"
                  name="email"
                  value={signInData.email}
                  onChange={handleSignInChange}
                  placeholder="Enter your email"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="signin-password">Password</label>
                <input
                  type="password"
                  id="signin-password"
                  name="password"
                  value={signInData.password}
                  onChange={handleSignInChange}
                  placeholder="Enter your password"
                  required
                />
              </div>
              <button type="submit" className="submit-button">Sign In</button>
              <p className="auth-switch">
                Don't have an account? <button type="button" className="link-button" onClick={() => setActiveTab('signup')}>Sign Up</button>
              </p>
            </form>
          </div>
        );
      case 'signup':
        return (
          <div className="signup-form-container">
            <form className="signup-form" onSubmit={handleSignUpSubmit}>
              <h2>Create Your Account</h2>
              <div className="form-group">
                <label htmlFor="name">Full Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={signUpData.name}
                  onChange={handleSignUpChange}
                  placeholder="Enter your full name"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={signUpData.email}
                  onChange={handleSignUpChange}
                  placeholder="Enter your email"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={signUpData.password}
                  onChange={handleSignUpChange}
                  placeholder="Create a password"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="confirmPassword">Confirm Password</label>
                <input
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  value={signUpData.confirmPassword}
                  onChange={handleSignUpChange}
                  placeholder="Confirm your password"
                  required
                />
              </div>
              <button type="submit" className="submit-button">Create Account</button>
            </form>
          </div>
        );
      case 'about':
        return (
          <div className="about-container">
            <div className="about-section">
              <div className="about-image-container">
                <img 
                  src="https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&q=80&w=1200&h=800"
                  alt="AI Technology Team"
                  className="about-image"
                />
              </div>
              <div className="about-content">
                <h1>About AI Agents Hub</h1>
                <p className="about-description">
                  Founded in 2024, AI Agents Hub is at the forefront of artificial intelligence innovation, 
                  providing cutting-edge AI solutions across multiple industries. Our mission is to make 
                  advanced AI technology accessible and practical for businesses of all sizes.
                </p>
                <div className="about-highlights">
                  <div className="highlight-item">
                    <span className="highlight-icon">🎯</span>
                    <h3>Our Mission</h3>
                    <p>To democratize AI technology and empower businesses with intelligent solutions.</p>
                  </div>
                  <div className="highlight-item">
                    <span className="highlight-icon">💡</span>
                    <h3>Innovation</h3>
                    <p>Continuous development of cutting-edge AI agents for evolving business needs.</p>
                  </div>
                  <div className="highlight-item">
                    <span className="highlight-icon">🤝</span>
                    <h3>Partnership</h3>
                    <p>Building strong, lasting relationships with our clients and partners.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      case 'home':
        return (
          <div className="home-container">
            <div className="hero-section">
              <img 
                src="https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&q=80&w=1200&h=600"
                alt="AI Agents"
                className="hero-image"
              />
              <div className="hero-content">
                <h1>Welcome to AI Agents Hub</h1>
                <p className="tagline">
                  Empowering Your Business with Intelligent AI Solutions
                </p>
                <p className="sub-tagline">
                  Discover, hire, and customize AI agents tailored to your industry needs
                </p>
                <button 
                  className="cta-button"
                  onClick={() => setActiveTab('hire-agents')}
                >
                  Explore AI Agents
                </button>
              </div>
            </div>
          </div>
        );
      case 'request':
        if (!loggedInUser) {
          return (
            <div className="auth-redirect-container">
              <h2>Please Sign In to Continue</h2>
              <p>You need to be signed in to request a new AI agent.</p>
              <div className="auth-buttons">
                <button className="auth-button" onClick={() => setActiveTab('signin')}>Sign In</button>
                <button className="auth-button secondary" onClick={() => setActiveTab('signup')}>Sign Up</button>
              </div>
            </div>
          );
        }
        return (
          <div className="request-form-container">
            <form className="request-form" onSubmit={handleSubmit}>
              <h2>Request New AI Agent</h2>
              
              <div className="form-group">
                <label htmlFor="agentName">Agent Name</label>
                <input
                  type="text"
                  id="agentName"
                  name="agentName"
                  value={formData.agentName}
                  onChange={handleFormChange}
                  placeholder="Enter desired agent name"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="category">Category</label>
                <select 
                  id="category"
                  name="category"
                  value={formData.category}
                  onChange={handleFormChange}
                  required
                >
                  <option value="">Select a category</option>
                  {categories.map((category, index) => (
                    <option key={index} value={category.name}>
                      {category.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="primaryFunction">Primary Function</label>
                <input
                  type="text"
                  id="primaryFunction"
                  name="primaryFunction"
                  value={formData.primaryFunction}
                  onChange={handleFormChange}
                  placeholder="Main task or purpose of the agent"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="requirements">Specific Requirements</label>
                <textarea
                  id="requirements"
                  name="requirements"
                  value={formData.requirements}
                  onChange={handleFormChange}
                  rows="4"
                  placeholder="Describe specific requirements or capabilities needed"
                  required
                ></textarea>
              </div>

              <div className="form-group">
                <label htmlFor="priority">Priority Level</label>
                <select 
                  id="priority"
                  name="priority"
                  value={formData.priority}
                  onChange={handleFormChange}
                  required
                >
                  <option value="">Select priority</option>
                  <option value="high">High</option>
                  <option value="medium">Medium</option>
                  <option value="low">Low</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="timeline">Expected Timeline</label>
                <input
                  type="date"
                  id="timeline"
                  name="timeline"
                  value={formData.timeline}
                  onChange={handleFormChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Additional Features</label>
                <div className="checkbox-group">
                  <label>
                    <input 
                      type="checkbox" 
                      name="features" 
                      value="api"
                      checked={formData.features.includes('api')}
                      onChange={handleFormChange}
                    /> API Integration
                  </label>
                  <label>
                    <input 
                      type="checkbox" 
                      name="features" 
                      value="dashboard"
                      checked={formData.features.includes('dashboard')}
                      onChange={handleFormChange}
                    /> Custom Dashboard
                  </label>
                  <label>
                    <input 
                      type="checkbox" 
                      name="features" 
                      value="reporting"
                      checked={formData.features.includes('reporting')}
                      onChange={handleFormChange}
                    /> Reporting Tools
                  </label>
                  <label>
                    <input 
                      type="checkbox" 
                      name="features" 
                      value="automation"
                      checked={formData.features.includes('automation')}
                      onChange={handleFormChange}
                    /> Automation Capabilities
                  </label>
                </div>
              </div>

              <div className="form-actions">
                <button type="submit" className="submit-button">Submit Request</button>
                <button 
                  type="button" 
                  className="reset-button"
                  onClick={() => setFormData({
                    agentName: '',
                    category: '',
                    primaryFunction: '',
                    requirements: '',
                    priority: '',
                    timeline: '',
                    features: []
                  })}
                >
                  Reset Form
                </button>
              </div>
            </form>
          </div>
        );
      default:
        if (selectedAgent && !loggedInUser) {
          return (
            <div className="auth-redirect-container">
              <h2>Please Sign In to View Details</h2>
              <p>You need to be signed in to view agent details and submit requests.</p>
              <div className="auth-buttons">
                <button className="auth-button" onClick={() => setActiveTab('signin')}>Sign In</button>
                <button className="auth-button secondary" onClick={() => setActiveTab('signup')}>Sign Up</button>
              </div>
            </div>
          );
        }
        return selectedAgent ? (
          <div className="agent-details-view">
            <button className="back-button" onClick={() => setSelectedAgent(null)}>
              ← Back to Agents
            </button>
            <div className="agent-details-content">
              <div className="agent-details-header">
                <span className="agent-large-icon">
                  {selectedAgent.name.includes("Diagnosis") ? "🔬" :
                   selectedAgent.name.includes("Care") ? "👨‍⚕️" :
                   selectedAgent.name.includes("Records") ? "📊" :
                   selectedAgent.name.includes("Blueprint") ? "📐" :
                   selectedAgent.name.includes("Cost") ? "💲" :
                   selectedAgent.name.includes("Safety") ? "⚠️" :
                   selectedAgent.name.includes("Review") ? "📝" :
                   selectedAgent.name.includes("Research") ? "⚖️" :
                   selectedAgent.name.includes("Contract") ? "📜" :
                   selectedAgent.name.includes("Forecasting") ? "📈" :
                   selectedAgent.name.includes("Tax") ? "💹" :
                   selectedAgent.name.includes("Fraud") ? "🔍" :
                   selectedAgent.name.includes("Campaign") ? "🎯" :
                   selectedAgent.name.includes("Social") ? "📱" :
                   selectedAgent.name.includes("Content") ? "✍️" :
                   selectedAgent.name.includes("Recruitment") ? "👥" :
                   selectedAgent.name.includes("Onboarding") ? "🎓" :
                   selectedAgent.name.includes("Policy") ? "📋" :
                   selectedAgent.name.includes("Workout") ? "💪" :
                   selectedAgent.name.includes("Nutrition") ? "🥗" :
                   selectedAgent.name.includes("Wellness") ? "🧘" :
                   selectedAgent.name.includes("Learning") ? "📚" :
                   selectedAgent.name.includes("Progress") ? "📊" :
                   selectedAgent.name.includes("Course") ? "✏️" :
                   "🤖"}
                </span>
                <div className="agent-info">
                  <h2>{selectedAgent.name}</h2>
                  <p className="agent-category">Category: {selectedAgent.category}</p>
                  <span className={`status-badge large ${selectedAgent.status.toLowerCase()}`}>
                    {selectedAgent.status}
                  </span>
                </div>
              </div>

              <div className="agent-details-body">
                <h3>Description</h3>
                <p className="detailed-description">
                  {selectedAgent.name.includes("Clinic Management") ? "An intelligent system for clinics that manages appointments, staff scheduling, inventory, billing, and patient flow. Features real-time analytics for clinic performance and resource optimization." :
                   selectedAgent.name.includes("Doctor's Assistant") ? "An AI assistant that helps doctors with patient documentation, medical research, treatment planning, and clinical decision support. Includes voice transcription and medical image analysis capabilities." :
                   selectedAgent.name.includes("Patient Care") ? "A comprehensive patient monitoring and care management system that tracks vital signs, medication adherence, lifestyle factors, and provides personalized health recommendations." :
                   selectedAgent.name.includes("Insurance Claims") ? "An automated system for processing insurance claims, verifying coverage, detecting fraud, and streamlining reimbursement workflows. Includes real-time eligibility verification and claims status tracking." :
                   "A specialized AI agent designed to streamline and optimize healthcare workflows."}
                </p>

                <div className="credit-info">
                  <h3>Credit Usage</h3>
                  <div className="credit-details">
                    <div className="credit-item">
                      <span className="credit-label">Base Cost:</span>
                      <span className="credit-value">
                        {selectedAgent.category === "Healthcare" ? "15" :
                         selectedAgent.category === "Legal" ? "20" :
                         selectedAgent.category === "Finance & Accounting" ? "25" :
                         selectedAgent.category === "Marketing" ? "18" :
                         selectedAgent.category === "Human Resources" ? "15" :
                         selectedAgent.category === "Fitness & Wellness" ? "12" :
                         selectedAgent.category === "Education" ? "15" :
                         "10"} credits
                      </span>
                    </div>
                    <div className="credit-item">
                      <span className="credit-label">Monthly Usage:</span>
                      <span className="credit-value">
                        {selectedAgent.category === "Healthcare" ? "5" :
                         selectedAgent.category === "Legal" ? "8" :
                         selectedAgent.category === "Finance & Accounting" ? "10" :
                         selectedAgent.category === "Marketing" ? "7" :
                         selectedAgent.category === "Human Resources" ? "5" :
                         selectedAgent.category === "Fitness & Wellness" ? "4" :
                         selectedAgent.category === "Education" ? "5" :
                         "3"} credits/month
                      </span>
                    </div>
                    <div className="credit-item">
                      <span className="credit-label">Features Add-on:</span>
                      <span className="credit-value">2-5 credits each</span>
                    </div>
                  </div>
                  <p className="credit-note">Note: Additional features and extended duration may require extra credits.</p>
                </div>

                <div className="action-form-container">
                  <h3>Task</h3>
                  <form className="action-form" onSubmit={handleActionFormSubmit}>
                    <div className="form-group">
                      <label htmlFor="startDate">Desired Start Date</label>
                      <input
                        type="date"
                        id="startDate"
                        name="startDate"
                        value={actionFormData.startDate}
                        onChange={handleActionFormChange}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="duration">Duration (in months)</label>
                      <select
                        id="duration"
                        name="duration"
                        value={actionFormData.duration}
                        onChange={handleActionFormChange}
                        required
                      >
                        <option value="">Select duration</option>
                        <option value="1">1 month</option>
                        <option value="3">3 months</option>
                        <option value="6">6 months</option>
                        <option value="12">12 months</option>
                      </select>
                    </div>

                    {/* Healthcare Specific Fields */}
                    {selectedAgent.category === "Healthcare" && (
                      <>
                        <div className="form-group">
                          <label htmlFor="useCase">Primary Use Case</label>
                          <select
                            id="useCase"
                            name="useCase"
                            onChange={handleActionFormChange}
                            required
                          >
                            {selectedAgent.name.includes("Clinic Management") && (
                              <>
                                <option value="">Select use case</option>
                                <option value="appointment">Appointment Management</option>
                                <option value="staffing">Staff Scheduling</option>
                                <option value="inventory">Inventory Management</option>
                                <option value="billing">Billing & Revenue</option>
                              </>
                            )}
                            {selectedAgent.name.includes("Doctor's Assistant") && (
                              <>
                                <option value="">Select use case</option>
                                <option value="documentation">Patient Documentation</option>
                                <option value="diagnosis">Clinical Decision Support</option>
                                <option value="research">Medical Research</option>
                                <option value="imaging">Image Analysis</option>
                              </>
                            )}
                            {selectedAgent.name.includes("Patient Care") && (
                              <>
                                <option value="">Select use case</option>
                                <option value="monitoring">Patient Monitoring</option>
                                <option value="medication">Medication Management</option>
                                <option value="lifestyle">Lifestyle Tracking</option>
                                <option value="telehealth">Telehealth Services</option>
                              </>
                            )}
                            {selectedAgent.name.includes("Insurance Claims") && (
                              <>
                                <option value="">Select use case</option>
                                <option value="processing">Claims Processing</option>
                                <option value="verification">Coverage Verification</option>
                                <option value="fraud">Fraud Detection</option>
                                <option value="appeals">Appeals Management</option>
                              </>
                            )}
                          </select>
                        </div>

                        <div className="form-group">
                          <label htmlFor="integrations">Required Integrations</label>
                          <div className="checkbox-group vertical">
                            <label>
                              <input type="checkbox" name="ehr" /> Electronic Health Records
                            </label>
                            <label>
                              <input type="checkbox" name="pms" /> Practice Management System
                            </label>
                            <label>
                              <input type="checkbox" name="lab" /> Laboratory Systems
                            </label>
                            <label>
                              <input type="checkbox" name="billing" /> Billing Systems
                            </label>
                          </div>
                        </div>

                        <div className="form-group">
                          <label htmlFor="compliance">Compliance & Security</label>
                          <div className="checkbox-group vertical">
                            <label>
                              <input type="checkbox" name="hipaa" /> HIPAA Compliance
                            </label>
                            <label>
                              <input type="checkbox" name="gdpr" /> GDPR Compliance
                            </label>
                            <label>
                              <input type="checkbox" name="encryption" /> End-to-End Encryption
                            </label>
                            <label>
                              <input type="checkbox" name="audit" /> Audit Trail
                            </label>
                          </div>
                        </div>

                        <div className="form-group">
                          <label htmlFor="scale">Deployment Scale</label>
                          <select
                            id="scale"
                            name="scale"
                            onChange={handleActionFormChange}
                            required
                          >
                            <option value="">Select scale</option>
                            <option value="single">Single Location</option>
                            <option value="multiple">Multiple Locations</option>
                            <option value="enterprise">Enterprise-wide</option>
                          </select>
                        </div>
                      </>
                    )}

                    {/* Legal Specific Fields */}
                    {selectedAgent.category === "Legal" && (
                      <>
                        <div className="form-group">
                          <label htmlFor="jurisdiction">Primary Jurisdiction</label>
                          <select
                            id="jurisdiction"
                            name="jurisdiction"
                            onChange={handleActionFormChange}
                            required
                          >
                            <option value="">Select jurisdiction</option>
                            <option value="federal">Federal</option>
                            <option value="state">State</option>
                            <option value="international">International</option>
                          </select>
                        </div>
                        <div className="form-group">
                          <label htmlFor="documentTypes">Document Types</label>
                          <div className="checkbox-group vertical">
                            <label>
                              <input type="checkbox" name="contracts" /> Contracts
                            </label>
                            <label>
                              <input type="checkbox" name="litigation" /> Litigation Documents
                            </label>
                            <label>
                              <input type="checkbox" name="compliance" /> Compliance Documents
                            </label>
                          </div>
                        </div>
                      </>
                    )}

                    {/* Finance Specific Fields */}
                    {selectedAgent.category === "Finance & Accounting" && (
                      <>
                        <div className="form-group">
                          <label htmlFor="dataAccess">Required Data Access</label>
                          <div className="checkbox-group vertical">
                            <label>
                              <input type="checkbox" name="marketData" /> Market Data
                            </label>
                            <label>
                              <input type="checkbox" name="transactions" /> Transaction History
                            </label>
                            <label>
                              <input type="checkbox" name="analytics" /> Analytics Tools
                            </label>
                          </div>
                        </div>
                        <div className="form-group">
                          <label htmlFor="reportingFrequency">Reporting Frequency</label>
                          <select
                            id="reportingFrequency"
                            name="reportingFrequency"
                            onChange={handleActionFormChange}
                            required
                          >
                            <option value="daily">Daily</option>
                            <option value="weekly">Weekly</option>
                            <option value="monthly">Monthly</option>
                          </select>
                        </div>
                      </>
                    )}

                    {/* Marketing Specific Fields */}
                    {selectedAgent.category === "Marketing" && (
                      <>
                        <div className="form-group">
                          <label htmlFor="platforms">Target Platforms</label>
                          <div className="checkbox-group vertical">
                            <label>
                              <input type="checkbox" name="social" /> Social Media
                            </label>
                            <label>
                              <input type="checkbox" name="email" /> Email Marketing
                            </label>
                            <label>
                              <input type="checkbox" name="web" /> Website Content
                            </label>
                          </div>
                        </div>
                        <div className="form-group">
                          <label htmlFor="budget">Monthly Budget Range</label>
                          <select
                            id="budget"
                            name="budget"
                            onChange={handleActionFormChange}
                          >
                            <option value="small">$1,000 - $5,000</option>
                            <option value="medium">$5,000 - $15,000</option>
                            <option value="large">$15,000+</option>
                          </select>
                        </div>
                      </>
                    )}

                    <div className="form-group">
                      <label htmlFor="requirements">Specific Requirements</label>
                      <textarea
                        id="requirements"
                        name="requirements"
                        value={actionFormData.requirements}
                        onChange={handleActionFormChange}
                        placeholder={selectedAgent.category === "Healthcare" ? "Describe specific medical use cases and integration requirements" :
                                   selectedAgent.category === "Legal" ? "Describe legal document types and specific compliance needs" :
                                   selectedAgent.category === "Finance & Accounting" ? "Describe financial analysis requirements and reporting needs" :
                                   selectedAgent.category === "Marketing" ? "Describe campaign objectives and target audience" :
                                   "Describe your specific requirements and use cases"}
                        rows="4"
                        required
                      ></textarea>
                    </div>

                    <div className="form-group">
                      <label htmlFor="additionalNotes">Additional Notes</label>
                      <textarea
                        id="additionalNotes"
                        name="additionalNotes"
                        value={actionFormData.additionalNotes}
                        onChange={handleActionFormChange}
                        placeholder="Any additional information or special requests"
                        rows="3"
                      ></textarea>
                    </div>

                    <button type="submit" className="submit-button">
                      Submit Request
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="categories-grid">
            {categories.map((category, index) => (
              <div 
                key={index} 
                className={`category-card ${expandedCategory === index ? 'expanded' : ''}`}
                onClick={() => setExpandedCategory(expandedCategory === index ? null : index)}
              >
                <div className="category-header">
                  <span className="category-icon">{category.icon}</span>
                  <h2 className="category-title">{category.name}</h2>
                </div>
                <p className="category-description">{category.description}</p>
                
                {expandedCategory === index && (
                  <div className="agents-grid">
                    {category.agents.map((agent, agentIndex) => (
                      <div 
                        key={agentIndex} 
                        className="agent-card"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleAgentSelect(agent, category);
                        }}
                      >
                        <div className="agent-header">
                          <span className="agent-icon">
                            {agent.name.includes("Diagnosis") ? "🔬" :
                             agent.name.includes("Care") ? "👨‍⚕️" :
                             agent.name.includes("Records") ? "📊" :
                             agent.name.includes("Blueprint") ? "📐" :
                             agent.name.includes("Cost") ? "💲" :
                             agent.name.includes("Safety") ? "⚠️" :
                             agent.name.includes("Review") ? "📝" :
                             agent.name.includes("Research") ? "⚖️" :
                             agent.name.includes("Contract") ? "📜" :
                             agent.name.includes("Forecasting") ? "📈" :
                             agent.name.includes("Tax") ? "💹" :
                             agent.name.includes("Fraud") ? "🔍" :
                             agent.name.includes("Campaign") ? "🎯" :
                             agent.name.includes("Social") ? "📱" :
                             agent.name.includes("Content") ? "✍️" :
                             agent.name.includes("Recruitment") ? "👥" :
                             agent.name.includes("Onboarding") ? "🎓" :
                             agent.name.includes("Policy") ? "📋" :
                             agent.name.includes("Workout") ? "💪" :
                             agent.name.includes("Nutrition") ? "🥗" :
                             agent.name.includes("Wellness") ? "🧘" :
                             agent.name.includes("Learning") ? "📚" :
                             agent.name.includes("Progress") ? "�" :
                             agent.name.includes("Course") ? "✏️" :
                             "🤖"}
                          </span>
                          <h3>{agent.name}</h3>
                          <span className={`status-badge ${agent.status.toLowerCase()}`}>
                            {agent.status}
                          </span>
                        </div>
                        <div className="agent-details">
                          <p className="agent-description">
                            {agent.name.includes("Diagnosis") ? "Analyzes medical data using advanced algorithms to assist in accurate disease diagnosis and treatment recommendations." :
                             agent.name.includes("Care Coordinator") ? "Orchestrates patient care plans and coordinates between healthcare providers for optimal treatment outcomes." :
                             agent.name.includes("Records") ? "Processes and analyzes healthcare records to identify patterns and improve patient care quality." :
                             agent.name.includes("Contractor AI") ? "Manages construction projects, schedules, resource allocation, and coordinates with subcontractors. Provides real-time progress tracking and budget monitoring." :
                             agent.name.includes("Architect Design") ? "Assists in architectural design, 3D modeling, space optimization, and ensures compliance with building codes and regulations. Offers sustainable design suggestions." :
                             agent.name.includes("Developer Planning") ? "Optimizes development projects, handles zoning analysis, feasibility studies, and project timeline planning. Integrates with BIM and project management tools." :
                             agent.name.includes("Document Review") ? "Reviews legal documents with high precision, identifying key clauses and potential issues." :
                             agent.name.includes("Legal Research") ? "Conducts comprehensive legal research across cases, statutes, and regulations." :
                             agent.name.includes("Contract") ? "Analyzes contracts for risks, obligations, and compliance with legal requirements." :
                             agent.name.includes("Forecasting") ? "Predicts financial trends using machine learning and market analysis." :
                             agent.name.includes("Tax") ? "Processes complex tax scenarios and provides optimization strategies." :
                             agent.name.includes("Fraud") ? "Detects suspicious patterns and prevents fraudulent financial activities." :
                             agent.name.includes("Campaign") ? "Optimizes marketing campaigns using real-time data and performance metrics." :
                             agent.name.includes("Social Media") ? "Manages social media presence and engagement across multiple platforms." :
                             agent.name.includes("Content Generator") ? "Creates engaging, SEO-optimized content for various marketing channels." :
                             agent.name.includes("Recruitment") ? "Screens candidates and matches them to job requirements efficiently." :
                             agent.name.includes("Onboarding") ? "Streamlines the employee onboarding process with automated workflows." :
                             agent.name.includes("Policy") ? "Provides guidance on HR policies and regulatory compliance." :
                             agent.name.includes("Workout") ? "Creates personalized workout plans based on individual goals and fitness levels." :
                             agent.name.includes("Nutrition") ? "Develops customized meal plans and provides nutritional guidance." :
                             agent.name.includes("Wellness") ? "Offers holistic wellness programs combining exercise, nutrition, and mental health." :
                             agent.name.includes("Learning") ? "Designs personalized learning paths based on individual goals and progress." :
                             agent.name.includes("Progress") ? "Tracks and analyzes student performance to optimize learning outcomes." :
                             agent.name.includes("Course") ? "Creates engaging educational content and interactive learning materials." :
                             "Specialized AI agent for advanced task automation"}
                          </p>
                          <div className="agent-features">
                            {agent.name.includes("Diagnosis") ? <>
                              <span className="feature">✓ Real-time diagnostic support</span>
                              <span className="feature">✓ Multi-source medical data analysis</span>
                              <span className="feature">✓ Evidence-based recommendations</span>
                            </> : agent.name.includes("Care Coordinator") ? <>
                              <span className="feature">✓ Automated care scheduling</span>
                              <span className="feature">✓ Provider communication</span>
                              <span className="feature">✓ Treatment tracking</span>
                            </> : agent.name.includes("Blueprint") ? <>
                              <span className="feature">✓ 3D modeling analysis</span>
                              <span className="feature">✓ Code compliance checking</span>
                              <span className="feature">✓ Optimization suggestions</span>
                            </> : agent.name.includes("Legal") ? <>
                              <span className="feature">✓ Multi-jurisdiction analysis</span>
                              <span className="feature">✓ Case law integration</span>
                              <span className="feature">✓ Legal precedent matching</span>
                            </> : agent.name.includes("Forecasting") ? <>
                              <span className="feature">✓ Predictive analytics</span>
                              <span className="feature">✓ Market trend analysis</span>
                              <span className="feature">✓ Risk assessment</span>
                            </> : agent.name.includes("Campaign") ? <>
                              <span className="feature">✓ A/B testing automation</span>
                              <span className="feature">✓ Performance analytics</span>
                              <span className="feature">✓ Audience targeting</span>
                            </> : agent.name.includes("Recruitment") ? <>
                              <span className="feature">✓ Resume parsing</span>
                              <span className="feature">✓ Skill matching</span>
                              <span className="feature">✓ Interview scheduling</span>
                            </> : agent.name.includes("Workout") ? <>
                              <span className="feature">✓ Custom exercise plans</span>
                              <span className="feature">✓ Progress tracking</span>
                              <span className="feature">✓ Form analysis</span>
                            </> : <>
                              <span className="feature">✓ Intelligent automation</span>
                              <span className="feature">✓ Real-time processing</span>
                              <span className="feature">✓ Data-driven insights</span>
                            </>}
                          </div>
                          <div className="credit-preview">
                            <div className="credit-preview-item">
                              <span>Base Cost: {category.name === "Healthcare" ? "15" :
                                              category.name === "Legal" ? "20" :
                                              category.name === "Finance & Accounting" ? "25" :
                                              category.name === "Marketing" ? "18" :
                                              category.name === "Human Resources" ? "15" :
                                              category.name === "Fitness & Wellness" ? "12" :
                                              category.name === "Education" ? "15" :
                                              "10"} credits</span>
                              <span>Monthly: {category.name === "Healthcare" ? "5" :
                                            category.name === "Legal" ? "8" :
                                            category.name === "Finance & Accounting" ? "10" :
                                            category.name === "Marketing" ? "7" :
                                            category.name === "Human Resources" ? "5" :
                                            category.name === "Fitness & Wellness" ? "4" :
                                            category.name === "Education" ? "5" :
                                            "3"} credits</span>
                            </div>
                          </div>
                          <button 
                            className="view-details-btn" 
                            onClick={(e) => {
                              e.stopPropagation();
                              if (!loggedInUser) {
                                setActiveTab('signin');
                              } else {
                                handleAgentSelect(agent, category);
                              }
                            }}
                          >
                            {loggedInUser ? 'View Details' : 'Sign In to View'}
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        );
    }
  };

  return (
    <Router>
    <div className="App">
      <header className="App-header">
        <div className="header-content">
          <Link to="/" className="logo-container">
            <span className="logo-icon">🤖</span>
            <span className="logo-text">AI Agents Hub</span>
          </Link>
          <nav className="App-nav">
            <Link 
              to="/"
              className={`nav-link ${activeTab === 'home' ? 'active' : ''}`}
              onClick={() => setActiveTab('home')}
            >
              Home
            </Link>
            <Link 
              to="/hire-agents"
              className={`nav-link ${activeTab === 'hire-agents' ? 'active' : ''}`}
              onClick={() => setActiveTab('hire-agents')}
            >
              Hire Agents
            </Link>
           
            <Link 
              to="/about"
              className={`nav-link ${activeTab === 'about' ? 'active' : ''}`}
              onClick={() => setActiveTab('about')}
            >
              About Us
            </Link>
          </nav>
          {loggedInUser ? (
            <div className="user-menu">
              <div className="user-profile-menu" onClick={() => setShowProfileMenu(!showProfileMenu)}>
                <img 
                  src={loggedInUser.avatar} 
                  alt={loggedInUser.name}
                  className="user-avatar"
                />
                <span className="user-name">Welcome, {loggedInUser.name}</span>
                <span className="credit-points">Credits: {loggedInUser.creditPoints}</span>
                {showProfileMenu && (
                  <div className="profile-dropdown">
                    <div className="profile-header">
                      <img 
                        src={loggedInUser.avatar} 
                        alt={loggedInUser.name}
                        className="profile-avatar"
                      />
                      <div className="profile-info">
                        <div className="profile-name">{loggedInUser.name}</div>
                        <div className="profile-email">{loggedInUser.email}</div>
                      </div>
                    </div>
                    <div className="profile-dropdown-divider"></div>
                    <div className="credit-points-display">
                      Available Credits: {loggedInUser.creditPoints}
                    </div>
                    <div className="profile-dropdown-item">
                      <span>👤</span> My Profile
                    </div>
                    <div className="profile-dropdown-item">
                      <span>📊</span> Credit History
                    </div>
                    <div className="profile-dropdown-item">
                      <span>⚙️</span> Settings
                    </div>
                    <div className="profile-dropdown-divider"></div>
                    <div className="profile-dropdown-item" onClick={handleSignOut}>
                      <span>🚪</span> Sign Out
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="auth-buttons">
              <Link 
                to="/signin"
                className="sign-in-btn"
                onClick={() => setActiveTab('signin')}
              >
                Sign In
              </Link>
              <Link 
                to="/signup"
                className="sign-up-btn"
                onClick={() => setActiveTab('signup')}
              >
                Sign Up
              </Link>
            </div>
          )}
        </div>
      </header>
      <main className="App-main">
        <Routes>
          <Route path="/" element={renderContent('home')} />
          <Route path="/hire-agents" element={renderContent('hire-agents')} />
          <Route path="/request" element={renderContent('request')} />
          <Route path="/about" element={renderContent('about')} />
          <Route path="/signin" element={renderContent('signin')} />
          <Route path="/signup" element={renderContent('signup')} />
        </Routes>
      </main>
      <footer className="App-footer">
        <div className="footer-content">
          <div className="footer-section">
            <h3>AI Agents Hub</h3>
            <p>Empowering businesses with intelligent AI solutions</p>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <button className="footer-link" onClick={() => setActiveTab('home')}>Home</button>
            <button className="footer-link" onClick={() => setActiveTab('hire-agents')}>Hire Agents</button>
            <button className="footer-link" onClick={() => setActiveTab('request')}>Request New Agent</button>
            
             <button className="footer-link" onClick={() => setActiveTab('about')}>About Us</button>
          </div>
          <div className="footer-section">
            <h4>Contact</h4>
            <p>Email: contact@aiagentshub.com</p>
            <p>Phone: (555) 123-4567</p>
          </div>
          <div className="footer-section">
            <h4>Follow Us</h4>
            <div className="social-links">
              <span className="social-icon">📱</span>
              <span className="social-icon">💼</span>
              <span className="social-icon">🐦</span>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 AI Agents Hub. All rights reserved.</p>
        </div>
      </footer>
    </div>
    </Router>
  );
}

export default App;
